import { useContext } from 'react';
import DynamicNftSaleContext from '../contexts/DynamicNftSaleContext';

const useDynamicNftSaleContext = () => useContext(DynamicNftSaleContext);

export default useDynamicNftSaleContext;
